export default __webpack_public_path__ + "static/provider-superb-37af2634f40a5728e7b0078bc5486763.jpg";